<template>
  <div>
    <div class="upload-image">
      <input-file
        :value="formulario.visaoExplodida.dados.fileImagem"
        returns="base64"
        class="col-12 col-md-3"
        :placeholder="
          $t('modulos.incertezas.formulario.dados_incerteza.adicionar_imagem')
        "
        visualizador
        :regras-personalizadas="[regraArquivo]"
        :image="formulario.visaoExplodida.dados.imagem"
        :disabled="ehVisualizar"
        @handle-upload="handleUpload"
        @clear="desvincularImagem"
        @nome-imagem="nomeImagem"
      />
    </div>
    <div>
      <main>
        <div v-if="!!temImagem" class="main-container">
          <v-hotspot
            :init-options="hotspot"
            :overlay-text="$t('modulos.modelo_instrumento.imagem')"
            :tela-edicao="ehTelaEdicao"
            :hotspots-db="hotspotsFromDb"
            @adiciona-dados-form="adicionaDadosForm"
          />
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import { InputFile } from '@/components/inputs';
import { VisaoExplodidaModel } from '@/common/models/cadastros/VisaoExplodidaModel';
import VueHotspot from '@/components/VueHotspot/VueHotspot.vue';

import { generateGuid } from '@/components/VueHotspot/utils/common.js';

export default {
  components: { InputFile, 'v-hotspot': VueHotspot },
  props: {
    form: { type: Object, default: null },
  },

  data() {
    return {
      temDados: false,
      mostrarVisaoExplodida: false,
      ehTelaEdicao: false,
      revisao: 'visualizacao',
      temImagem: false,
      hotspot: {
        image: null,
        editable: true,
        interactivity: 'hover',
      },
      formulario: {
        visaoExplodida: {
          dados: new VisaoExplodidaModel(),
        },
      },
      hotspotsFromDb: [],
    };
  },
  computed: {
    ehVisualizar() {
      return this.$route.name === 'modelo-instrumento-visualizar';
    },
  },

  mounted() {
    if (this.form.id) {
      this.setarValoresIniciais(this.form);
      this.temDados = true;
      this.ehTelaEdicao = true;
    } else {
      this.ehTelaEdicao = false;
      this.mostrarVisaoExplodida = true;
    }
  },
  methods: {
    setarValoresIniciais(formulario) {
      this.hotspot.image = formulario.imagem;

      if (formulario.vistasExplodidas.length) {
        this.hotspotsFromDb = formulario.vistasExplodidas.map((pontoImagem) => {
          return {
            x: pontoImagem.coordenadaX,
            y: pontoImagem.coordenadaY,
            iterador: pontoImagem.iterador.toString(),
            itemId: pontoImagem.item.id,
            codigo: pontoImagem.item.codigo,
            fabricante: pontoImagem.item.participanteFabricante?.nome,
            descricao: pontoImagem.item.descricao,
            pontoId: pontoImagem.pontoId,
            id: generateGuid(),
          };
        });
      }

      if (!formulario.imagem && !formulario.vistasExplodidas.length) {
        this.mostrarVisaoExplodida = false;
        this.temImagem = false;
        return;
      }
      this.mostrarVisaoExplodida = true;
      this.temImagem = true;
    },
    changeEditable(conf) {
      if (!conf) return;
      conf.editable = !conf.editable;
    },
    regraArquivo(v) {
      if (!v) return (this.validado = false);
      if (v?.type == 'image/png') return (this.validado = true);
      else {
        this.validado = false;
        return this.$t(`modulos.colaborador.validacoes.permitido_png`);
      }
    },
    handleUpload(file) {
      this.form.imagem = file;

      this.hotspot.image = file;
      this.temImagem = !!file;
      this.mostrarVisaoExplodida = true;
    },
    desvincularImagem() {
      this.form.imagem = null;
      this.form.nomeImagem = null;
    },
    nomeImagem(nomeImagem) {
      this.form.nomeImagem = nomeImagem ? nomeImagem : null;
    },
    adicionaDadosForm(value) {
      this.form.vistasExplodidas = [...value];
    },
  },
};
</script>

<style>
.upload-image {
  display: flex;
  align-items: center;
}

.button-save {
  margin-top: 2.4rem;
}
.desc {
  margin-bottom: 3em;
  color: #7f8c8d;
}

.main-container {
  padding: 1rem;
}
</style>
import { log } from 'xstate/lib/actions';
